import React from 'react';
import { TagsState } from '../../model/map/map';
import { WP_Filter_Children, WP_Parent_Tag } from '../../model/tags/tags';
import { FilterModal } from './FilterModal';

export interface FilterProps {
  className: string;
  multipleSelect: boolean;
  categories: WP_Parent_Tag[];
  selectParentTag: (number, taxonomy) => void;
  setSelectedParentTag: (number) => void;
  selectedParentTagId: number | null;
  childrenTags: WP_Filter_Children[] | null;
  selectSubTag: (children, parentId, checked) => void;
  isSubTagSelected: (children, parentId) => boolean;
  selectedSubTags: TagsState[] | null;
  setAllSelected: (selectedParentTagId, checked) => void;
  isFiltered: () => boolean | undefined;
  onResetFilter: () => void;
  backUrl: string;
  showModal: boolean;
  openModal: (boolean) => void;
}

export const Filter: React.FC<FilterProps> = (props) => {
  return <FilterModal {...props}>{props.children}</FilterModal>;
};
